import { differenceInYears } from "date-fns";

const parseUKDate = (date) => {
  const dateValues = date.split("/");
  const day = parseInt(dateValues[0], 10);
  const monthIndex = parseInt(dateValues[1], 10) - 1;
  const year = parseInt(dateValues[2], 10);

  return new Date(year, monthIndex, day);
};

const calculateAge = (input) => {
  const birthDate = parseUKDate(input);
  return differenceInYears(Date.now(), birthDate);
};

const mtaInfoMessage = `
  <p>Dependents must be 24 years old and under when added to a policy.
  If you are making changes to a dependent already on a policy,
  they may remain until the end of the policy even after they turn 25 years old.</p>
`;

const handleDependentAgeNotice = (inputId) => {
  $(inputId)
    .closest(".control-block")
    .append('<div class="dependent-age-notice"></div>');

  $(inputId).on("change", function () {
    const dependentAge = calculateAge(this.value);
    const noticeElement = $(this)
      .closest(".control-block")
      .find(".dependent-age-notice");

    if (dependentAge === 25) {
      noticeElement.html(mtaInfoMessage);
    } else {
      noticeElement.html("");
    }
  });
};

const dependents = [1, 2, 3, 4, 5, 6];

const checkHealthDependentAges = () => {
  if (window.location.pathname.indexOf("/mta/") !== -1) {
    dependents.forEach((num) => {
      handleDependentAgeNotice(`#health_dependent_dob_${num}`);
    });
  }
};

export {
  dependents,
  parseUKDate,
  calculateAge,
  handleDependentAgeNotice,
  checkHealthDependentAges,
};
